import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { baseConfig } from "../../config";
import SideBar from "../SideBar";
import Header from "../Header";
import Footer from "../Footer";
import "./Layout.css";
import { Authenticator, Loader, useAuthenticator } from "@aws-amplify/ui-react";
import { I18n } from "aws-amplify/utils";
import TaskWindow from "./TaskWindow";

export interface LayoutProps {
  children?: React.ReactNode;
}

const Layout = (props) => {
  const { authStatus } = useAuthenticator(context => [context.authStatus]);
  const navigate = useNavigate();

  useEffect(() => {
    if (authStatus !== 'authenticated' && authStatus !== 'configuring') {
      navigate('/');
    }
  }, [authStatus]);

  I18n.putVocabulariesForLanguage('en', {
    'Sign In': 'Entra', 
    'Sign in': 'Entra', 
    'Signing in': 'Caricamento...',
    'Change Password': 'Cambia password',
    'Enter your username': 'Inserisci username',
    'Enter your Password': 'Inserisci nuova password',
    'Confirm Password': 'Conferma password',
    'Please confirm your Password': 'Conferma password',
    'username is required to signIn': 'Errore: specificare un username',
    'password is required to signIn': 'Errore: specificare una password', 
    'User does not exist.': 'Errore: utente non esistente', 
    'Incorrect username or password.': 'Errore: username o password errata', 
    'Send code': 'Invia codice (via email)', 
    'Back to Sign In': 'Torna al login', 
    'Forgot your password?': 'Se hai dimenticato la password, clicca qui',
    'Reset Password': 'Reimposta password',
    'Sending...': 'Invio...',
    'New Password': 'Nuova password',
    'Code': 'Codice',
    'Code *': 'Inserisci il codice ricevuto via mail',
    'Submit': 'Invia',
    'Resend': 'Clicca qui per ricevere un nuovo codice',
    'User is disabled.': 'L\'utenza è stata bloccata',
    'Attempt limit exceeded, please try after some time.': 'Numero di tentativi massimo raggiunto, riprovare più tardi.'
  });

  return (
    <>
      {authStatus === 'configuring' && <Loader />}
      {authStatus !== 'authenticated' ? 
        <div style={{paddingTop: '50px'}}>
          <div style={{textAlign: 'center', marginBottom: '30px'}}>
            <img
              src={process.env.PUBLIC_URL + "/logo.png"}
              alt="logo"
              width="300"
            />
          </div>
          <Authenticator hideSignUp formFields={{signIn: 
            {
              username: {placeholder: 'Username', autocomplete: "off"}, 
              password: {placeholder: 'Password', autocomplete: "new-password"}
            }}}/>
        </div> 
      : 
        <div className="layout-container">
          {baseConfig.header ? <Header /> : <></>}
          <SideBar role={props.role} />
          <div className="page-container">
            <TaskWindow />
            <Outlet />
          </div>
          {baseConfig.footer ? <Footer /> : <></>}
        </div>}
    </>
  );
};

export default Layout;
